import styled from 'styled-components'
import Icon from '@mdi/react'

import theme from 'theme_'
import CommonLinkButton from 'components/Button/CommonLinkButton'

export const KebabMenuIcon = styled(Icon)`
  color: ${theme.colors.horizonOrange};
`

export const KebabMenuItemsUl = styled.ul`
  margin: 0;
  padding: ${theme.spacing.xs} 0;
  list-style: none;
  background-color: ${theme.colors.white};
  box-shadow: 0 4px 40px ${theme.colors.commonShadow};
  border-radius: 8px;
  min-width: 146px;
  animation: ${theme.animations.fadeIn} 0.1s ease;
`

export const KebabMenuButton = styled(CommonLinkButton)`
  padding: 0;
`
